import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { Compagnie } from '@shared/models';
import { MatIconAnchor } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { FormatFileSizePipe } from '../../pipes/format-file-size.pipe';
import { FormatTimePipe } from '../../pipes/format-time.pipe';

@Component({
  selector: 'app-table-company',
  templateUrl: './table-company.component.html',
  styleUrl: './table-company.component.scss',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIconAnchor,
    RouterLink,
    MatIcon,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    FormatFileSizePipe,
    FormatTimePipe,
  ],
})
export class TableCompanyComponent implements OnChanges {
  @Input({ required: true }) companies: Compagnie[];

  protected dataSource: MatTableDataSource<Compagnie>;

  protected displayedColumns: string[] = [
    'id',
    'name',
    'usersLength',
    'currentData',
    'currentTime',
    'monthlyData',
    'monthlyTime',
    'treatmentDeletion',
    'analysisDeletion',
    'archivedIncidentDeletion',
    'settings',
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companies) {
      this.dataSource = new MatTableDataSource(this.companies);
    }
  }
}
